import { render } from "./FeatInfoEventBox.vue?vue&type=template&id=c9a8e3ba&scoped=true"
import script from "./FeatInfoEventBox.vue?vue&type=script&lang=js"
export * from "./FeatInfoEventBox.vue?vue&type=script&lang=js"

import "./FeatInfoEventBox.vue?vue&type=style&index=0&id=c9a8e3ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c9a8e3ba"

export default script